import Moment from "moment";

/**
 * Consist of functions which format input parameters for date format etc.
 */

export const formatDate = (date: string): string =>
  Moment.utc(date)
    .local()
    .format("MMM D, YYYY h:mm A");

export const localNumber = (data: number | null, fallback?: string): string =>
  data ? data.toLocaleString("en-IN") : fallback || "";
